import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { withInject } from '@piwikpro/platform';

const Domains = withInject({
  Domains: 'DomainsCrate.components.Domains',
})(({ Domains: D }: any) => <D />);

export const Route = createFileRoute('/_secured/administration/account/domains')({
  component: Domains,
});
